import { createComponentsRegistrySiteAssets, ILibraryTopology } from '@wix/thunderbolt-components-registry/siteAssets'
import type { ComponentsMappers } from '@wix/thunderbolt-components-native'

import { componentsMappers } from '@wix/thunderbolt-components-native'
import type { FetchFn, MetricsReporter } from '@wix/thunderbolt-becky-types'

export const getComponentMappers = async ({
	fetchFn,
	registryLibrariesTopology,
	metricsReporter,
}: {
	fetchFn: FetchFn
	registryLibrariesTopology: string
	metricsReporter: MetricsReporter
}): Promise<ComponentsMappers> => {
	const libraries: Array<ILibraryTopology> = registryLibrariesTopology ? JSON.parse(registryLibrariesTopology) : []

	const registry = await createComponentsRegistrySiteAssets({
		libraries,
		modulesLoader: {
			relativeUrl: () => {
				throw new Error('ModulesLoader `relativeUrl` method should not be used')
			},
			absoluteUrl: async (url) => {
				const response = await fetchFn(url)
				return response.text() as any
			},
		},
		runAndReport: (metric, fn) => {
			return metricsReporter.runAsyncAndReport(fn, metric)
		},
	})

	const models = await registry.loadComponentMappers()

	return {
		...componentsMappers,
		...models,
	} as ComponentsMappers
}
